export default __webpack_public_path__ + "static/media/outfit-burberry.2897e56a.jpg";